import { render } from "./NewsCTA.vue?vue&type=template&id=e2177b30&scoped=true"
import script from "./NewsCTA.vue?vue&type=script&lang=js"
export * from "./NewsCTA.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2177b30"]])

export default __exports__